<template>
  <ASpin v-bind="$attrs" :spinning="loading" size="large" wrapper-class-name="w-100">
    <slot>
      <div class="position-static" :class="[loaderHeight, { 'spinner-opacity': !isFullPage }]">
        <div
          v-if="isFullPage"
          class="loading-tip loading-tip--elevated d-flex align-items-center justify-content-center min-vh-100"
        >
          <p class="loading-tip__text">
            <span class="loading-tip__eyebrow">{{ t('Pro Tip:') }}</span>
            {{ showTip }}
          </p>
        </div>
      </div>
    </slot>
  </ASpin>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { iksTips } from '@/constants/iksTips'
import { useI18n } from 'vue-i18n'

import ASpin from 'ant-design-vue/es/spin'

const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: true,
  },
  loaderHeight: {
    type: String,
    required: false,
    default: 'min-vh-100',
  },
  isFullPage: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()

const tip = computed(() => iksTips[Math.floor(Math.random() * iksTips.length)])
const showTip = computed(() => (props.isFullPage ? tip.value : undefined))
</script>

<style lang="scss">
.ant-spin-blur {
  opacity: 1 !important;

  &::after {
    opacity: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as vars;

.spinner-opacity {
  opacity: 0.5 !important;
}

.loading-tip--elevated {
  padding-top: 200px;
  width: 100%;

  .loading-tip__text {
    position: relative;
    display: inline-block;
    background: #fff;
    color: black;
    border-radius: 15px;
    padding: 1rem 1.25rem 1.1rem;
    box-shadow:
      0 10px 30px rgba(vars.$primary, 0.08),
      0 2px 10px rgba(15, 23, 42, 0.06);
    text-align: center;

    font-size: 16px;
    &::before {
      content: '';
      position: absolute;
      inset: 0 0 auto 0;
      height: 4px;
      border-radius: 14px 14px 0 0;
      background: linear-gradient(90deg, vars.$primary, lighten(vars.$primary, 15%));
    }
  }

  .loading-tip__eyebrow {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: vars.$primary;
    margin-right: 0.4rem;
  }
}
</style>
